import { Validators } from '@angular/forms';

export const EMAIL_PATTERN = '^[äöüÄÖÜß\\w.+-]{1,64}@[äöüÄÖÜß\\w.-]{1,249}\\.[A-Za-z]{2,63}$';

export const emailPattern = Validators.pattern(EMAIL_PATTERN);
